import { jsx as _jsx } from "react/jsx-runtime";
export function HandleErrorDot({ top, zIndex, label }) {
    return /*#__PURE__*/ _jsx("span", {
        className: "absolute bg-danger-solid rounded-full pointer-events-none",
        style: {
            width: 6,
            height: 6,
            top: top - 3,
            right: -3,
            zIndex
        },
        "aria-label": label,
        title: label
    });
}

//# sourceMappingURL=HandleErrorDot.js.map